import { render, staticRenderFns } from "./DiscoveryStatsChartLegend.vue?vue&type=template&id=26d14628"
import script from "./DiscoveryStatsChartLegend.vue?vue&type=script&lang=js"
export * from "./DiscoveryStatsChartLegend.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryStatsChartLegend.vue?vue&type=style&index=0&id=26d14628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports